<nz-spin nzTip="Please wait..." [nzSpinning]="authService.isLoading">
    <router-outlet></router-outlet>
</nz-spin>